var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{ 'd-none': _vm.item.displayOn && !_vm.display_none_check}},[_c('h5',{staticClass:"mt-2 mb-4 font-weight-semibold"},[_vm._v(_vm._s(_vm.item.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }